import React,{useState,useEffect} from 'react'
import { businessDays, getWeekDayName } from '../scheduleServices';
import scheduleUpdateServices from '../scheduleUpdateServices';



import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Switch, Tooltip } from '@mui/material';
import { Add, Edit } from '@mui/icons-material';
import { useAlert } from '../../../../context/AlertContext';
import { useAppData } from '../../../../context/AppDataContext';
import moment from 'moment/moment';

function DayScheduleForm({dayNo,data, callBack }) {
    const {AppAlert} = useAlert();
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const {associatedClinicList,getAppDataById} = useAppData();

    const [clinicId,setClinicId] = useState("");
    const [startTime,setStartTime] = useState("09:00");
    const [endTime,setEndTime] =useState("16:00");
    const [avgProcessTime,setAvgProcessTime] = useState(15);
    const [maxToken,setMaxToken] = useState(1);
    
    
    const addNew = ()=>{
        setDialogStatus(true);
    }

    const updateData = ()=>{
        setClinicId(data.clinicId);
        setStartTime(data.startTime);
        setEndTime(data.endTime);
        setAvgProcessTime(data.avgProcessTime);
        setMaxToken(data.maxToken);
        setDialogStatus(true);
        
    }

    const handleClose = () =>{
        setDialogStatus(false)
    }

    const onSubmit = () => {
        let payload = {
            clinicId:clinicId,
            dayNo:dayNo,
            startTime:startTime,
            endTime :endTime,
            avgProcessTime:avgProcessTime,
            maxToken:maxToken
        }
        if(data){ //Updating Existing
          payload.id = data.id;
        }
        setSavingStatus(true);

        scheduleUpdateServices.save(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack(res.id)
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }
    
    const handleClinicChange = (e) =>{
        setClinicId(e.target.value)
    }

    const handleDayStatusChange = (e) =>{
        if(data){ //Updating Existing
            let payload = {
                id:data.id,
                dayStatus:e.target.checked,
            }
            scheduleUpdateServices.save(payload).then(res=>{
                AppAlert(res.msg);
                setDialogStatus(false);
                callBack(res.id)
            }).catch(error=>{
                AppAlert(error.msg,"error");
            }).finally(()=>{
                setSavingStatus(false);
            })
        }
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add Schedule</button>
                </Tooltip>
            }
            {data &&
                <div className='card'>
                    
                    <div className={data.dayStatus == 1 ? 'card-header py-1 bg-success text-white':'card-header py-1'}>
                        <span>
                            {associatedClinicList && getAppDataById(associatedClinicList,data.clinicId).title}
                        </span>
                        <span className='float-end'>
                            <Switch checked={data.dayStatus}
                                color='dark'
                                size="small" 
                                onChange={handleDayStatusChange}
                            />
                        </span>
                    </div>

                    <div className='card-body py-1 '>
                        <span className='fw-bold'>
                            { moment(data.startTime,"HH:mm:ss").format("h:mm A")} TO {moment(data.endTime,"HH:mm:ss").format("h:mm A")}
                        </span>
                        <span className='float-end'>
                            <Tooltip title="Update">
                                <IconButton onClick={updateData} style={{padding:"0px"}}>
                                    <Edit/>
                                </IconButton>
                            </Tooltip>
                        </span>
                    </div>
                    
                </div>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                maxWidth="md"
            >
                <DialogTitle className='bg-dark text-white mb-3 py-2' >{getWeekDayName(dayNo)}</DialogTitle>
                <DialogContent>
                    <div className='row'>
                        <div className='col-md-12 mb-2'>
                            <label className="form-label fw-bold">Select Clinic</label>
                            <select value={clinicId} onChange={handleClinicChange} className='form-control' >
                                <option value={""}>--Select Clinic--</option>
                                {associatedClinicList && associatedClinicList.map(clinic =>
                                    <option value={clinic.id}>{clinic.title}</option>
                                )}
                            </select>
                        </div>
                        <div className='col-md-12 mb-2'>
                            <label className="form-label fw-bold">Start Time</label>
                            <input className='form-control' type="time" value={startTime} onChange={(e)=>setStartTime(e.target.value)}  ></input>
                        </div>
                        <div className='col-md-12 mb-2'>
                            <label className="fform-label fw-bold">End Time</label>
                            <input className='form-control' type="time" value={endTime} onChange={(e)=>setEndTime(e.target.value)}  ></input>
                        </div>

                        <div className='col-md-12 mb-2'>
                            <label className="fform-label fw-bold">Slot Time (In Minutes)</label>
                            <input className='form-control' type="number" value={avgProcessTime} 
                                onChange={
                                    (e)=>{
                                        if(e.target.value>=15){
                                            setAvgProcessTime(e.target.value)
                                        }
                                    }
                                }  
                            />
                        </div>
                        <div className='col-md-12 mb-2'>
                            <label className="fform-label fw-bold">Max Visitor Per Slot</label>
                            <input className='form-control' type="number" value={maxToken} 
                                onChange={
                                    (e)=>{
                                        if(e.target.value>=1){
                                            setMaxToken(e.target.value)
                                        }
                                    }
                                }  
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <div className="row mt-3">
                        <div className='col-md-12'>
                            {savingInProgress ?
                                <LinearProgress/>
                                :
                                <>
                                    <button className="btn btn-primary float-end" onClick={onSubmit} type="button" >Save</button>
                                    <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                </>
                            }
                        </div>
                        <div className='col-md-12'>
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    )
}


function DaySchedule({dayNo}) {

    const [dayScheduleList,setDayScheduleList] = useState(null);

    const getDayScheduleList = () =>{
        scheduleUpdateServices.getAssociateScheduleByDay(dayNo).then(res=>{
            console.log(res);
            setDayScheduleList(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }

    useEffect(()=>{
        getDayScheduleList();
    },[dayNo])
    return (
        <div className='row'>
            {dayScheduleList && dayScheduleList.map((daySchedule,i)=>
                <div className='col-md-3' key={daySchedule.id}>
                    <h6 className='m-1 fw-bold'>Shift No : {i+1}</h6>   
                    <DayScheduleForm  dayNo={dayNo} data={daySchedule} callBack={getDayScheduleList} />
                </div>
            )}
            {dayScheduleList && dayScheduleList.length < 2 && 
                <div className='col-md-3'>
                    <DayScheduleForm dayNo={dayNo} callBack={getDayScheduleList} />
                </div>
            }
            
        </div>
    )

}

export default DaySchedule